/* eslint-disable camelcase */
const configEl = window.document.getElementById('configuration')
const domConfig = configEl?.innerHTML || '{}'
const config = JSON.parse(domConfig)

const {
  canonicalLinks,
  contact,
  contactActionsOrder,
  environment,
  locale,
  loggingBaseUrl,
  personalisation,
  snowplow,
  tenant,
  userManagerSettings
} = config

export default {
  chapiBaseUrl() {
    return personalisation.baseUrl
  },
  requestContext() {
    return personalisation.requestContext
  },
  personalisation() {
    return {
      ...config.personalisation,
      locale: config.locale,
      analytics: {
        globalContext: window.$spGlobalContext,
        enabled: snowplow.enabled
      },
      tenant,
      environment
    }
  },
  personalisationEnabled() {
    return personalisation.enabled
  },
  userManagerSettings() {
    return {
      ...userManagerSettings,
      redirect_uri: `${window.location.origin}/help/signin-oidc`, // Match the app's auth callback full URL
      post_logout_redirect_uri: `${window.location.origin}/help/signin-oidc`
    }
  }
}

export {
  canonicalLinks,
  contactActionsOrder,
  contact,
  environment,
  locale,
  loggingBaseUrl,
  snowplow,
  tenant
}
